module.exports = __webpack_public_path__ + "img/金属材料学4_8.e57f026e.png";